import { BreadcrumbChip } from "./breadcrumbs";
import { Breadcrumbs } from "@mui/material";
import { FRONTEND_ROUTES } from "../frontendRoutes";
import { MODEL_PROPTYPES } from "../models";
import PropTypes from "prop-types";
import { formatDateISO } from "../utils/formatTime";

export const ExperimentMissionBreadcrumbs = ({ experimentMission }) => {
    const company = experimentMission.Experiment.Site.Contract.Company;
    const contract = experimentMission.Experiment.Site.Contract;
    const site = experimentMission.Experiment.Site;
    const experiment = experimentMission.Experiment;
    const mission = experimentMission.Mission;

    const companyUrl = `/${FRONTEND_ROUTES.ORDERS}/${FRONTEND_ROUTES.CONTRACT}?companyUuid=${company.uuid}`;
    const contractUrl = `/${FRONTEND_ROUTES.ORDERS}/${FRONTEND_ROUTES.CONTRACT}/${contract.uuid}`;
    const siteUrl = `/${FRONTEND_ROUTES.ORDERS}/${FRONTEND_ROUTES.CONTRACT}/${contract.uuid}/${FRONTEND_ROUTES.SITE}/${site.uuid}`;
    const missionUrl = `/${FRONTEND_ROUTES.TRAFFIC}/${FRONTEND_ROUTES.INBOUND_TRAFFIC}/${FRONTEND_ROUTES.INBOUND_TRAFFIC_DETAILS}/${mission.uuid}`;

    return (
        <Breadcrumbs separator="/" mb={1}>
            <BreadcrumbChip label={company.name} destinationUrl={companyUrl} />
            <BreadcrumbChip
                label={contract.name}
                destinationUrl={contractUrl}
            />
            <BreadcrumbChip label={site.name} destinationUrl={siteUrl} />
            <BreadcrumbChip label={experiment.name} />
            <BreadcrumbChip
                label={formatDateISO(mission.date)}
                destinationUrl={missionUrl}
            />
        </Breadcrumbs>
    );
};

ExperimentMissionBreadcrumbs.propTypes = {
    experimentMission: PropTypes.shape(MODEL_PROPTYPES.ExperimentMission)
        .isRequired,
};
